import { callApi } from './common'

export default {
  list: (userSeqs) => callApi(`iam/user/${userSeqs}/ip`),
  get: (seq) => callApi(`iam/user/ip/${seq}`),
  add: (userSeqs, params) => callApi(`iam/user/${userSeqs}/ip`, params, 'post'),
  modify: (seq, params) => callApi(`iam/user/ip/${seq}`, params, 'put'),
  remove: (seq) => callApi(`iam/user/ip/${seq}`, {}, 'delete'),
}
